import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import WindowIcon from '@mui/icons-material/Window';
import Box from '@mui/material/Box';
import React from 'react';
import { ViewTypes } from '../../../types/shell';

import ViewSwitchButton from './ViewSwitchButton';

interface IProps {
  activeView: ViewTypes;
  setActiveView: (view: ViewTypes) => void;
}

const ViewSwitcher: React.FC<IProps> = ({ activeView, setActiveView }) => {
  const isListActive = activeView === ViewTypes.LIST;
  const isGridActive = activeView === ViewTypes.GRID;

  const getColor = (isActive: boolean) => (isActive ? 'action' : 'disabled');
  const getBorderStyle = (isActive: boolean) => `1px solid ${isActive ? 'rgba(0, 0, 0, 0.12)' : 'transparent'}`;

  return (
    <Box sx={{ display: 'flex' }}>
      <ViewSwitchButton
        isActive={isListActive}
        onClick={() => setActiveView(ViewTypes.LIST)}
        icon={<FormatListBulletedIcon sx={{ width: 24, height: 24 }} color={getColor(isListActive)} />}
        borderRadius="4px 0 0 4px"
        borderStyle={getBorderStyle(isListActive)}
      />
      <ViewSwitchButton
        isActive={isGridActive}
        onClick={() => setActiveView(ViewTypes.GRID)}
        icon={<WindowIcon sx={{ width: 24, height: 24 }} color={getColor(isGridActive)} />}
        borderRadius="0 4px 4px 0"
        borderStyle={getBorderStyle(isGridActive)}
      />
    </Box>
  );
};

export default ViewSwitcher;
